<template>
  <div class="container pb-100">
    <div class="row mb-40">
      <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
        <div class="section-title text-center style3">
          <span>Before &amp; After</span>
          <h2>See Samples Of How <span>We Treat</span> Our Patients</h2>
        </div>
      </div>
    </div>

    <div class="promo-video-wrap bg-f ptb-100">
      <div class="circle">
        <div
          class="play-video"
          v-on:click="isPopupMethod(isPopup)"
          style="cursor: pointer"
        >
          <i class="flaticon-play-2"></i>
        </div>
        <div class="text">
          <p>
            <span
              v-for="(char, index) in text"
              :key="index"
              :style="getCharStyle(index)"
            >
              {{ char }}
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="popup-video" v-if="isPopup">
    <div class="d-table">
      <div class="d-table-cell">
        <div class="container">
          <div class="popup-overlay-close" v-on:click="isPopupMethod(isPopup)">
            <div class="popup-overlay-close-line"></div>
            <div class="popup-overlay-close-line"></div>
          </div>

          <div class="play-video">
            <iframe
              class="responsive-iframe"
              src="https://www.youtube.com/embed/DublqkOSBBA"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "SeeSamples",
  data: () => ({
    isPopup: false,
    text: "See Samples Of How We Treat Our Patients",
  }),
  methods: {
    isPopupMethod(isPopup) {
      return (this.isPopup = !isPopup);
    },
    getCharStyle(index) {
      return {
        transform: `rotate(${index * 9}deg)`,
      };
    },
  },
});
</script>